export const PRICE_REDUCTION_TEXT = 'Price cut';
